// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, recordOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isIntegrationsVoucherGroupsTagsResult = objectOf({
  info: string,
  undo_identifier: string,
  undo_data: objectOf({
    app_group_id: string,
    desired_state: recordOf({
      key: string,
      value: arrayOf(string),
    }),
  }),
  all_tags: arrayOf(string),
  used_tags: arrayOf(string),
});
